import React from 'react';

const STATUS_CONFIG = {
  // Utworzona - żółty
  created: { label: 'Utworzona', color: 'var(--warning)', bgColor: 'var(--warning-light)', icon: '📝' },

  // Potwierdzona - niebieski
  confirmed: { label: 'Potwierdzona', color: 'var(--info)', bgColor: 'var(--info-light)', icon: '✓' },
  offers_prepared: { label: 'Oferty gotowe', color: 'var(--info)', bgColor: 'var(--info-light)', icon: '📋' },
  offer_selected: { label: 'Oferta wybrana', color: 'var(--info)', bgColor: 'var(--info-light)', icon: '✓' },

  // W drodze - niebieski
  dispatched_by_sender: { label: 'Nadana', color: 'var(--info)', bgColor: 'var(--info-light)', icon: '📤' },
  collected_from_sender: { label: 'Odebrana', color: 'var(--info)', bgColor: 'var(--info-light)', icon: '📦' },
  taken_by_courier: { label: 'U kuriera', color: 'var(--info)', bgColor: 'var(--info-light)', icon: '🚚' },
  adopted_at_source_branch: { label: 'W oddziale', color: 'var(--info)', bgColor: 'var(--info-light)', icon: '🏢' },
  sent_from_source_branch: { label: 'W transporcie', color: 'var(--info)', bgColor: 'var(--info-light)', icon: '🚛' },
  adopted_at_sorting_center: { label: 'W sortowni', color: 'var(--info)', bgColor: 'var(--info-light)', icon: '🏭' },
  sent_from_sorting_center: { label: 'Z sortowni', color: 'var(--info)', bgColor: 'var(--info-light)', icon: '🚛' },
  adopted_at_target_branch: { label: 'W oddziale docelowym', color: 'var(--info)', bgColor: 'var(--info-light)', icon: '🏢' },

  // Gotowe do odbioru - zielony
  ready_to_pickup: { label: 'Gotowa do odbioru', color: 'var(--success)', bgColor: 'var(--success-light)', icon: '📬' },
  out_for_delivery: { label: 'W doręczeniu', color: 'var(--success)', bgColor: 'var(--success-light)', icon: '🏃' },
  stack_in_box_machine: { label: 'W paczkomacie', color: 'var(--success)', bgColor: 'var(--success-light)', icon: '📦' },

  // Dostarczona - zielony ciemny
  delivered: { label: 'Doręczona', color: 'var(--success)', bgColor: 'var(--success-light)', icon: '✅' },
  pickup_time_expired: { label: 'Odebrana', color: 'var(--success)', bgColor: 'var(--success-light)', icon: '✅' },

  // Przypomnienia - pomarańczowy
  pickup_reminder_sent: { label: 'Przypomnienie', color: 'var(--warning)', bgColor: 'var(--warning-light)', icon: '⏰' },
  avizo: { label: 'Awizo', color: 'var(--warning)', bgColor: 'var(--warning-light)', icon: '📨' },
  customer_delivering: { label: 'Klient odbiera', color: 'var(--warning)', bgColor: 'var(--warning-light)', icon: '🚶' },

  // Problemy - czerwony
  returned_to_sender: { label: 'Zwrot', color: 'var(--danger)', bgColor: 'var(--danger-light)', icon: '↩️' },
  undelivered: { label: 'Niedoręczona', color: 'var(--danger)', bgColor: 'var(--danger-light)', icon: '❌' },
  claim_registered: { label: 'Reklamacja', color: 'var(--danger)', bgColor: 'var(--danger-light)', icon: '⚠️' },

  // Anulowana - szary
  cancelled: { label: 'Anulowana', color: 'var(--text-muted)', bgColor: 'var(--border)', icon: '🚫' }
};

const ShipmentStatusBadge = ({ status, showIcon = true, size = 'normal' }) => {
  const config = STATUS_CONFIG[status] || {
    label: status || 'Nieznany',
    color: 'var(--text-muted)',
    bgColor: 'var(--border)',
    icon: '❓'
  };

  const sizeStyles = {
    small: { padding: '2px 6px', fontSize: '9px' },
    normal: { padding: '4px 8px', fontSize: '10px' },
    large: { padding: '6px 12px', fontSize: '12px' }
  };

  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: '4px',
        ...sizeStyles[size],
        backgroundColor: config.bgColor,
        color: config.color,
        borderRadius: '4px',
        fontWeight: '600',
        whiteSpace: 'nowrap'
      }}
    >
      {showIcon && <span>{config.icon}</span>}
      {config.label}
    </span>
  );
};

// Export statusów dla użycia w filtrach
export const SHIPMENT_STATUSES = {
  all: { label: 'Wszystkie', value: '' },
  in_transit: {
    label: 'W drodze',
    value: 'in_transit',
    statuses: ['confirmed', 'dispatched_by_sender', 'collected_from_sender', 'taken_by_courier',
               'adopted_at_source_branch', 'sent_from_source_branch', 'adopted_at_sorting_center',
               'sent_from_sorting_center', 'adopted_at_target_branch']
  },
  ready: {
    label: 'Gotowe do odbioru',
    value: 'ready',
    statuses: ['ready_to_pickup', 'out_for_delivery', 'stack_in_box_machine']
  },
  delivered: {
    label: 'Dostarczone',
    value: 'delivered',
    statuses: ['delivered', 'pickup_time_expired']
  },
  problem: {
    label: 'Problemy',
    value: 'problem',
    statuses: ['returned_to_sender', 'undelivered', 'claim_registered', 'avizo', 'pickup_reminder_sent']
  },
  cancelled: {
    label: 'Anulowane',
    value: 'cancelled',
    statuses: ['cancelled']
  }
};

// Funkcja pomocnicza do kategoryzacji statusu
export const getStatusCategory = (status) => {
  for (const [key, category] of Object.entries(SHIPMENT_STATUSES)) {
    if (category.statuses?.includes(status)) {
      return key;
    }
  }
  return 'all';
};

export default ShipmentStatusBadge;
